/* Prendas Payas — quick-view estilo mvrk: el producto se pide sin salir de la mesa.
   Click en un plato de la carta → modal papel con fotos, talla y añadir a la cesta.
   Sin JS (o si falla el fetch) el enlace navega a la ficha normal. */
(function () {
  var mesa = document.querySelector('.pp-mesa');
  if (!mesa) return;

  var dinero = function (cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  var modal, ultimoFoco;

  function cerrar() {
    if (!modal) return;
    var el = modal;
    modal = null;
    if (window.Motion && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Motion.animate(el.querySelector('.pp-modal__card'), { opacity: 0, y: 30, scale: 0.97 }, { duration: 0.22 });
      Motion.animate(el, { opacity: 0 }, { duration: 0.25 }).then(function () { el.remove(); });
    } else {
      el.remove();
    }
    document.documentElement.classList.remove('pp-modal-abierto');
    if (ultimoFoco) ultimoFoco.focus();
  }

  function abrir(p, url) {
    ultimoFoco = document.activeElement;
    var imgs = (p.images || []).slice(0, 6);
    var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    if (desc.length > 180) desc = desc.slice(0, 180).replace(/\s\S*$/, '') + '…';

    var variantes = p.variants || [];
    var unaTalla = variantes.length === 1;

    modal = document.createElement('div');
    modal.className = 'pp-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', p.title);
    modal.innerHTML =
      '<div class="pp-modal__fondo"></div>' +
      '<div class="pp-modal__card">' +
        '<button class="pp-modal__cerrar" aria-label="Cerrar">×</button>' +
        '<div class="pp-modal__fotos">' +
          '<div class="pp-modal__carril">' + imgs.map(function (src, i) {
            return '<img src="' + src + '&width=700" alt="" loading="' + (i ? 'lazy' : 'eager') + '">';
          }).join('') + '</div>' +
          (imgs.length > 1 ? '<button class="pp-modal__nav pp-modal__nav--prev" aria-label="Anterior">‹</button><button class="pp-modal__nav pp-modal__nav--next" aria-label="Siguiente">›</button>' : '') +
        '</div>' +
        '<div class="pp-modal__info">' +
          '<h3 class="pp-modal__titulo">' + p.title + '</h3>' +
          '<p class="pp-modal__precio">' + dinero(p.price) + ' <small>impuestos incluidos</small></p>' +
          (desc ? '<p class="pp-modal__desc">' + desc + '</p>' : '') +
          '<div class="pp-modal__tallas" role="radiogroup" aria-label="Talla">' +
            (unaTalla
              ? '<span class="pp-modal__unatalla">talla única</span>'
              : variantes.map(function (v, i) {
                  return '<button class="pp-modal__talla" role="radio" aria-checked="false" data-id="' + v.id + '"' +
                    (v.available ? '' : ' disabled') + '>' + v.title + (v.available ? '' : '<i>agotado</i>') + '</button>';
                }).join('')) +
          '</div>' +
          '<button class="pp-modal__pedir"' + (unaTalla ? ' data-id="' + variantes[0].id + '"' : ' disabled') + '>Pedir a la mesa</button>' +
          '<a class="pp-modal__ficha" href="' + url + '">ver ficha completa →</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    document.documentElement.classList.add('pp-modal-abierto');

    var card = modal.querySelector('.pp-modal__card');
    if (window.Motion && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Motion.animate(modal, { opacity: [0, 1] }, { duration: 0.25 });
      Motion.animate(card, { opacity: [0, 1], y: [46, 0], scale: [0.96, 1] }, { type: 'spring', stiffness: 170, damping: 20 });
    }

    /* carrusel */
    var carril = modal.querySelector('.pp-modal__carril');
    var idx = 0;
    function mover(d) {
      idx = (idx + d + imgs.length) % imgs.length;
      carril.style.transform = 'translateX(' + (-idx * 100) + '%)';
    }
    modal.addEventListener('click', function (e) {
      if (e.target.closest('.pp-modal__nav--prev')) mover(-1);
      if (e.target.closest('.pp-modal__nav--next')) mover(1);
      if (e.target.closest('.pp-modal__cerrar') || e.target.classList.contains('pp-modal__fondo')) cerrar();

      var talla = e.target.closest('.pp-modal__talla');
      if (talla && !talla.disabled) {
        modal.querySelectorAll('.pp-modal__talla').forEach(function (t) {
          t.classList.remove('is-elegida');
          t.setAttribute('aria-checked', 'false');
        });
        talla.classList.add('is-elegida');
        talla.setAttribute('aria-checked', 'true');
        var pedir = modal.querySelector('.pp-modal__pedir');
        pedir.disabled = false;
        pedir.dataset.id = talla.dataset.id;
        if (window.Motion) Motion.animate(talla, { scale: [1, 1.1, 1] }, { duration: 0.3 });
      }

      var pedir = e.target.closest('.pp-modal__pedir');
      if (pedir && !pedir.disabled && pedir.dataset.id) {
        pedir.disabled = true;
        pedir.textContent = 'Marchando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(pedir.dataset.id), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return fetch('/cart.js').then(function (r2) { return r2.json(); });
        }).then(function (cart) {
          pedir.textContent = 'En la cesta ✓';
          pedir.classList.add('is-servido');
          document.querySelectorAll('.pp-mesa__cesta, .pp-prod-barra__cesta').forEach(function (c) {
            c.textContent = 'cesta · ' + cart.item_count;
            if (window.Motion) Motion.animate(c, { scale: [1, 1.35, 1] }, { duration: 0.45 });
          });
          if (window.Motion) Motion.animate(pedir, { scale: [1, 0.94, 1.04, 1] }, { duration: 0.4 });
          setTimeout(function () {
            if (!modal) return;
            pedir.disabled = false;
            pedir.classList.remove('is-servido');
            pedir.textContent = 'Pedir otra';
          }, 1800);
        }).catch(function () {
          pedir.disabled = false;
          pedir.textContent = 'Error — reintenta';
        });
      }
    });

    modal.querySelector('.pp-modal__cerrar').focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal) cerrar();
  });

  mesa.addEventListener('click', function (e) {
    var plato = e.target.closest('.pp-plato[data-handle]');
    if (!plato) return;
    e.preventDefault();
    var url = plato.getAttribute('href');
    fetch('/products/' + plato.dataset.handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { abrir(p, url); })
      .catch(function () { location.href = url; });
  });
})();
